// @ts-nocheck
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import iconHeartSelected from "assets/icons/heart-selected.svg";
import iconHeartUnselected from "assets/icons/heart-unselected.svg";
import _ from "lodash";
import moment from "moment-timezone";
import styled from "styled-components";

import EditEventModal from "components/modals/edit-event-modal";
import { EventTab } from "components/pages/events-page";
import Gallery from "components/tools/gallery";
import ReviewsSection from "components/tools/reviews-section";
import { Breadcrumb, Button, Container, Frame, Row, RowWrapper, TExtra } from "components/ui-kit/styled-templates";

import OECDs from "constants/OECDs.json";
import { EVENT_TYPES_OPTIONS, resolveFileUrl } from "constants/config";

import EventsApi from "api/events-api";
import ReviewsApi from "api/reviews-api";
import UniversityApi from "api/university-api";
import UserApi from "api/user-api";

import ModalsService from "services/modals-service";

import useBodyBackground from "hooks/useBodyBackground";
import { useStorageListener } from "hooks/useStorage";

import { EModals, ERoles } from "types/enums";
import ClubsApi from "../../api/clubs-api";

const EventsPublicPage = () => {
    const { t, i18n } = useTranslation();
    let isRu = i18n.language === "ru";

    const { eventId } = useParams();
    const user = useStorageListener(`user`, {});
    const reviews = useStorageListener(`reviews`, []);
    const role: ERoles = useStorageListener(`user.userRole`, ERoles.Guest);
    useBodyBackground(`white`);

    const { details: event, universityId, clubId } = useStorageListener(`events.${eventId}`, {});
    const university = useStorageListener(`universities.${universityId}.details`, {});

    const club = useStorageListener(`clubs.${event?.clubId}`, {});
    console.log('render: club = ', club);
    console.log('render: event = ', event);

    const events = useStorageListener((state) => _.values(state?.events)?.filter?.((i) => i?.universityId === universityId) ?? []);

    const isStarred = _.get(user, "starredEvents", []).includes(eventId);

    const eventReviews = _(reviews).filter((i) => i.published).filter({ eventId }).value();

    const handlers = {
        openEditEventModal: () => {
            ModalsService.showModal(EModals.CreateEvent, { mode: `edit`, data: _.find(events, { id: eventId }) });
        },
    };

    const startEvent = () => {
        UserApi.toggleEventStar(eventId);
    };

    useEffect(() => {
        UniversityApi.getAllUniversitiesData();
    }, []);

    useEffect(() => {
        ClubsApi.getAllClubs();
        EventsApi.getEvents();
        ReviewsApi.getAllReviews();
    }, []);

    useEffect(() => {
        // scroll to top after render and after article loaded
        try{
            setTimeout(() => {
                console.log('scroll to top!!!');
                window.scrollTo({
                    top: 0,
                    behavior: 'auto'
                });
                const element = document.getElementById("header_logo");
                if (element) {
                    element.scrollIntoView({
                        behavior: "auto", // Optional for smooth scrolling
                        block: "start",     // Aligns the element at the top
                    });
                }
            }, 100);
        }catch(exc){

        }
    }, []);


    return (
        <>
            {role === ERoles.Admin && <EditEventModal />}

            <Container>
                <Breadcrumb.Wrapper>
                    <Breadcrumb.Item to="/">{t("j84jsap4w1")}</Breadcrumb.Item>
                    <Breadcrumb.Item to="/universities">{t("2lgbhrpjsvc")}</Breadcrumb.Item>
                </Breadcrumb.Wrapper>
            </Container>
            <Row extra={`width: inherit; background: #F4F4F4;`}>
                <Container extra={`align-items: flex-start;`}>
                    <HeaderRowWrapper event={event}>
                        <div className="flex flex-row gap-2 items-center">
                            <h1>{_.get(event, `name`, `...`)}</h1>
                            <img
                                src={isStarred ? iconHeartSelected : iconHeartUnselected}
                                alt="Start"
                                className="w-10 h-10 object-fit cursor-pointer"
                                onClick={startEvent}
                            />
                        </div>
                        <Row extra={`gap: 16px;`}>
                            <Link to={role === ERoles.Guest ? `/login` : `/create-event-booking/${eventId}`}>
                                <Button>{t("xn9xg4nymx")}</Button>
                            </Link>
                            {/* <Button variant="outlined">Написать отзыв</Button> */}
                        </Row>
                    </HeaderRowWrapper>
                </Container>
            </Row>
            <Container extra={`align-items: flex-start; margin: 25px 0 50px 0;`}>
                {(role === ERoles.Admin || ERoles.ClubsAdmin == role || ERoles.ClubsUniAdmin == role) && (
                    <Button extra="margin: 25px 0;" onClick={handlers.openEditEventModal}>
                        {t("10s0r7bevrpm")}
                    </Button>
                )}
                <Row className={"event_item_row"}>
                    <Frame extra="align-items: flex-start;" className={"event_item_frame"}>
                        <EventTab.Type extra="margin-bottom: 20px;">
                            {t("1nq4oigqfvf")} {EVENT_TYPES_OPTIONS?.find?.((i) => i?.value === event?.type)?.label}
                        </EventTab.Type>

                        {/* Специализация скрыта по требованию
                        {event?.type == 'active_tourism' ? null :
                            <EventTab.Type extra="margin-bottom: 20px;">
                                {t("e7b02koyjyl")} {OECDs?.find?.((i) => i?.["WoS"] === event?.["WoS"])?.["3_LevelRus"]}
                            </EventTab.Type>
                        }
                        */}

                        <EventTab.DetailsWrapper extra="> * { display: flex; flex-direction: column; gap: 8px; };">
                            <div>
                                <div>{t("io6pjdkgqgo")}</div>
                               <span>
                                    <strong>
                                        {event?.price}
                                    </strong>
                                    <span style={{fontSize: '14px', opacity: 0.5}} >
                                        {event?.currency == undefined ? '' : ` (${event?.currency})`}
                                    </span>
                               </span>
                            </div>
                            <div>
                                <div>{t("3lxtqbvsbsv")}</div>
                                <strong>
                                    {moment(event?.dates?.from).format(`DD.MM.YYYY`)} - {moment(event?.dates?.to).format(`DD.MM.YYYY`)}
                                </strong>
                            </div>
                            {event?.from_time && (
                                <div>
                                    <div>
                                        <div>{isRu  ? 'Время начала:' : 'Time of the start:'}</div>
                                        <strong>
                                            {event?.from_time}
                                        </strong>
                                    </div>
                                    {/*<div>*/}
                                    {/*    <div>{isR}</div>*/}
                                    {/*    <strong>*/}
                                    {/*        {moment(event?.dates?.from).format(`DD.MM.YYYY`)} - {moment(event?.dates?.to).format(`DD.MM.YYYY`)}*/}
                                    {/*    </strong>*/}
                                    {/*</div>*/}
                                </div>
                            )}

                        </EventTab.DetailsWrapper>
                        <Frame extra="gap: 5px; align-items: flex-start; > * { min-height: 15px; };">
                            {event?.description?.split?.(`\n`).map?.((item, index) => (
                                <div key={index}>{item}</div>
                            ))}
                        </Frame>

                        {event?.additionalInformation && (
                            <Frame extra="gap: 5px; align-items: flex-start; margin-top: 20px;">
                                <strong>{isRu ? 'Дополнительная информация' : 'Additional information'}</strong>
                                {event?.additionalInformation?.split?.(`\n`).map?.((item, index) => (
                                    <div key={index}>{item}</div>
                                ))}
                            </Frame>
                        )}

                        {event?.contactsInformation && (
                            <Frame extra="gap: 5px; align-items: flex-start; margin-top: 20px;">
                                <strong>{isRu ? 'Контактные данные' : 'Contact information'}</strong>
                                {event?.contactsInformation?.split?.(`\n`).map?.((item, index) => (
                                    <div key={index}>{item}</div>
                                ))}
                            </Frame>
                        )}

                        {event?.requiredDocumentsInformation && (
                            <Frame extra="gap: 5px; align-items: flex-start; margin-top: 20px;">
                                <strong>{isRu ? 'Перечень необходимых документов и требования' : 'Required documents and requirements'}</strong>
                                {event?.requiredDocumentsInformation?.split?.(`\n`).map?.((item, index) => (
                                    <div key={index}>{item}</div>
                                ))}
                            </Frame>
                        )}

                        {event?.importantInformation && (
                            <Frame extra="gap: 5px; align-items: flex-start; margin-top: 20px;">
                                <strong>{isRu ? 'Важная информация' : 'Important information'}</strong>
                                {event?.importantInformation?.split?.(`\n`).map?.((item, index) => (
                                    <div key={index}>{item}</div>
                                ))}
                            </Frame>
                        )}
                    </Frame>
                    <MainInfo.DetailsWrapper className={"event_item_details_wrapper"}>
                        <MainInfo.DetailsItem extra="width: 300px !important;">
                            <div>{t("r2epld5xb6")}</div>
                            <strong>{_.get(university, `name`, `-`)}</strong>

                            {event?.clubId == undefined ? null :
                                <>
                                    <div>{'Студтурклуб'}</div>
                                    <strong>{_.get(club, `details.name`, `-`)}</strong>
                                </>
                            }

                            <a href={university.site}>{_.get(university, `site`, `-`)}</a>
                        </MainInfo.DetailsItem>
                        <MainInfo.DetailsItem extra="width: 300px !important;">
                            <div>{t("qok3r57t8yn")}</div>
                            <strong>{_.get(university, `region`, `-`)}</strong>
                        </MainInfo.DetailsItem>
                        {/* <MainInfo.DetailsItem extra="width: 300px !important;">
                            <div>Город</div>
                            <strong>{_.get(university, `city`, `-`)}</strong>
                        </MainInfo.DetailsItem> */}
                    </MainInfo.DetailsWrapper>
                </Row>
                {event?.photos?.length > 0 && (
                    <>
                        <h3>{t("omsmm9noc0m")}</h3>
                        <Gallery photos={event?.photos} extra="margin-top: 15px;" />
                    </>
                )}
                {event?.video && (
                    <>
                        <h3>{t("gj7fwspuj2")}</h3>
                        <Video src={resolveFileUrl(event?.video)} controls extra="margin-top: 15px;" />
                    </>
                )}
            </Container>

            <ReviewsSection reviews={eventReviews} />
        </>
    );
};

const Video = styled.video<{ extra?: TExtra }>`
    width: 100%;

    ${({ extra }) => extra}
`;

const HeaderRowWrapper = styled(RowWrapper)<{ event: Object }>`
    ${({ theme, event }) => _.isEmpty(_.get(event, `name`)) && `color: ${theme.red};`}

    h1 {
        flex: 1;
    }

    @media (max-width: 991px) {
        flex-direction: column;
        h1 {
            margin: 20px 0;
            line-height: 56px;
        }

        div {
            margin: 0 0 32px 0;
        }
    }
`;

const MainInfo = {
    Photo: styled(Frame)<{ src: string }>`
        width: 100%;
        max-width: 87vw;
        height: 380px;
        flex: 1;
        border-radius: 12px;
        background: url("${({ src }) => src}") no-repeat center center / cover;

        @media (max-width: 991px) {
            max-height: 180px;
            flex: unset;
        }
    `,
    DetailsWrapper: styled(Frame)`
        width: 100%;
        max-width: 87vw;
        min-height: 380px;
        flex: 1;
        border-radius: 12px;
        background: ${({ theme }) => theme.lightblue};

        padding: 32px;
        box-sizing: border-box;

        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;

        gap: 5px;

        @media (max-width: 991px) {
            gap: 15px;
        }
    `,
    DetailsItem: styled(Frame)`
        width: calc(50% - 3px);
        align-items: flex-start;
        font-size: 15px;
        line-height: 20px;

        a {
            color: ${({ theme }) => theme.blue};
            font-weight: 600;
        }

        strong {
            margin: 8px 0 16px;
            min-height: 20px;
        }

        @media (max-width: 991px) {
            width: 100%;
        }
    `,
};

export default EventsPublicPage;
